import {Environment} from './environment.type';
import {environment as prodEnv} from './environment.prod';

export const environment: Environment = {
  ...prodEnv,
  ENV: 'dev',
  //BASE_API_URL: 'http://localhost:8000/'
  BASE_API_URL: 'https://backend.compliancedesk.noro.dev'

};
